'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var React = require('react');
var styled = require('styled-components');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty__default["default"](target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var StyledIconButton = styled__default["default"].button.withConfig({
  componentId: "sc-79wajw-0"
})(function (_ref) {
  var s = _ref.s;
  return _objectSpread({
    background: 'transparent',
    border: 'none',
    fontSize: 'inherit',
    padding: '0 0.5rem',
    cursor: 'pointer',
    '&:hover': {
      background: 'transparent'
    }
  }, s);
});
var hoverStyle = {
  opacity: 0.3,
  transition: 'opacity 100ms ease-in-out',
  '&:hover': {
    opacity: 1,
    background: 'transparent'
  }
};
var IconButton = function IconButton(_ref2) {
  var _ref2$hover = _ref2.hover,
    hover = _ref2$hover === void 0 ? false : _ref2$hover,
    onClick = _ref2.onClick,
    onMouseEnter = _ref2.onMouseEnter,
    onMouseLeave = _ref2.onMouseLeave,
    onFocus = _ref2.onFocus,
    children = _ref2.children,
    onBlur = _ref2.onBlur,
    _ref2$ariaLabel = _ref2.ariaLabel,
    ariaLabel = _ref2$ariaLabel === void 0 ? 'clickable icon' : _ref2$ariaLabel,
    _ref2$s = _ref2.s,
    s = _ref2$s === void 0 ? {} : _ref2$s,
    _ref2$dataTest = _ref2['data-test'],
    dataTest = _ref2$dataTest === void 0 ? null : _ref2$dataTest;
  return /*#__PURE__*/React__default["default"].createElement(StyledIconButton, {
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    onFocus: onFocus,
    onClick: onClick,
    onBlur: onBlur,
    s: _objectSpread(_objectSpread({}, s), hover ? hoverStyle : {}),
    "aria-label": ariaLabel,
    "data-test": dataTest,
    role: "button"
  }, children);
};

exports["default"] = IconButton;
